<template>
    <div class="media-icon" v-if="item.isOk">
        <!-- Small item badges //-->
        <div v-if="item.has360 || item.isInteractive || item.isImage || item.hasShares" class="thumbnail-badges">
            <div v-if="item.has360" class="thumbnail-badge" content="360" v-tippy="{arrow: true}">
                <svg viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="st0" d="M9.486 17.73h-1.4c0 .9.3 1.7 1.1 2.2.8.4 1.7.4 2.6.1.8-.3 1.4-1.1 1.5-2 .1-.6-.3-2-1.1-2 1.7-.6.8-3-.5-3.4-1.7-.6-3.3.4-3.4 2.3.3 0 .9.1 1.2 0s.1 0 .2-.4c0-.3.2-.5.4-.7.5-.3 1.1-.1 1.3.3.1.2.1.3.1.5 0 .4-.2.7-.5.9-.2.1-.9 0-1 .1-.1.3-.1.7 0 1 .1.1.8 0 1 .1.3.1.5.3.6.6.6 1.9-2.1 2.3-2.1.4zM16.086 13.93c.5-.4 1.5-.2 1.5.5h1.4c-.2-2.3-3.4-2.6-4.4-.8-.6.9-.6 2.2-.6 3.2 0 .9.2 2 .9 2.7 1.5 1.5 3.9.4 4.2-1.6.1-1-.2-2-1.1-2.6-.8-.5-2-.4-2.6.3.1-.4.1-1.3.7-1.7zm-.3 2.8c.4-.4 1.1-.5 1.5-.1l.2.2c.7 1.1-.6 3.1-1.7 1.8-.4-.4-.5-1.4 0-1.9zM20.286 13.83c-.7 1.5-.7 4 .2 5.4.9 1.5 3.5 1.3 4.2-.3.7-1.5.7-3.9-.1-5.4.1.2.2.3 0 0s-.1-.2 0 0c-1-1.6-3.6-1.3-4.3.3zm3.1 4.1c-.1.5-.2 1-.8 1.1-.5.1-.9-.2-1-.7 0 .1.1.2 0 0s0-.1 0 0c-.3-1.2-.3-2.5-.1-3.7.2-.9 1.4-1.4 1.8-.3s.3 2.6.1 3.6z"/><path class="st0" d="M33.486 10.43l-6.5-1 2.4 6.1 1.2-1.5c1.1 2.8-1.7 5.9-4.1 7.1-3.5 1.9-7.6 2.4-11.5 2.3-4.5-.1-10.5-1.1-13.2-5.2-2.6-4 .7-7.4 4.3-9-4.3 1.7-7.6 5.8-4.1 10.2 3 3.8 8.7 5.1 13.4 5.3s9.9-.3 13.9-2.9c3.1-2.2 5-6.3 3-9.7z"/></svg>
            </div>
           <div v-if="item.isInteractive" class="thumbnail-badge" content="Interactive 3D capture" v-tippy="{arrow: true}">
               <i class="fal fa-cube" aria-hidden="true"></i>
            </div>
            <div v-if="!item.isInteractive && !item.has360 && item.isImage" class="thumbnail-badge" content="Uploaded Image" v-tippy="{arrow: true}">
               <i class="fal fa-image-polaroid" aria-hidden="true"></i>
            </div>
            <div v-if="item.hasShares" class="thumbnail-badge" content="Shared" v-tippy="{arrow: true}">
                <i class="fas fa-share-alt" aria-hidden="true"></i>
            </div>
        </div>

        <div v-if="item.hasDuration" class="thumbnail-timecode" content="Duration" v-tippy="{arrow: true}">
            {{ item.duration }}
        </div>

        <!-- Big item badges //-->
        <template v-if="item.isVideo">
            <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                <i class="fas fa-play fa-stack-1x"></i>
            </span>
        </template>

        <template v-if="item.isPdf">
            <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                <i class="fas fa-file-pdf fa-stack-1x"></i>
            </span>
        </template>

        <template v-if="item.isWord">
            <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                <i class="fas fa-file-word fa-stack-1x"></i>
            </span>
        </template>

        <template v-if="item.isPowerpoint">
            <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                <i class="fas fa-file-powerpoint fa-stack-1x"></i>
            </span>
        </template>

        <template v-if="item.isExcel">
            <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                <i class="fas fa-file-excel fa-stack-1x"></i>
            </span>
        </template>

        <template v-if="!item.isPdf && !item.isWord && !item.isPowerpoint && !item.isExcel && item.isDocument">
            <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                <i class="fas fa-file fa-stack-1x"></i>
            </span>
        </template>

         <template v-if="item.type === 'other'">
            <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                <i class="icon-text">{{ item.getDisplayFilenameExtension.toUpperCase() }}</i>
            </span>
        </template>

        <template v-if="item.isMediaSet && !condensed">
            <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
                <i class="fas fa-folders fa-stack-1x"></i>
            </span>
        </template>

        <!-- public / private flag //-->
        <div
            v-if="!item.isMediaSet"
            class="badge"
            :class="{'is-private': !item.public, 'is-public': item.public}"
            :title="item.publicText"
            v-tippy="{arrow: true}">

            <i class="fas" :class="{'fa-lock': !item.public, 'fa-lock-open': item.public}"></i>
        </div>

    </div>
</template>

<script>
export default {
    name: 'MediaIcon',
    props: {
        item: {
            type: Object,
            required: true,
        },
        condensed: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.media-icon {

    .thumbnail-badge {
        cursor: help;
    }

    .fa-stack {
        position: absolute;
        margin: auto;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        font-size: 3.5rem;

        i:first-child {
            color: white;
            opacity: 0.7;
            text-shadow: 2px 2px 10px rgba(black, 0.4);
        }

        i:last-child {
            color: inherit;
            opacity: 1;
            font-size: 2.7rem;
            margin-left: 2px;

            &.icon-text {
                display: block;
                position: relative;
                z-index: 999;
                font-style: normal;
                font-weight: 600;
                font-size: 50%;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                text-align: center;
            }
        }
    }

    .is-public, .is-private {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        color: $text-color;
        font-size: 1.4rem;
        padding: 5px 6px;

        cursor: help;
    }

    .is-public {
        color: white;
        background: $brand-success;
    }
}
</style>
